//      
import React from 'react';

export default React.createContext(null);



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/view/context/droppable-context.js